import React from "react";
import { ChevronRight } from "@ptsd/uikit";
import { Button, styled, Text, View, XStack } from "tamagui";

const ResearchBreadcrumbsItem = styled(Text, {
  fontFamily: "$subtitle",
  fontWeight: "$6",
  fontSize: "$7",
  lineHeight: "$7",
  variants: {
    active: {
      true: {
        color: "$gray-primary-900",
      },
      false: {
        color: "$gray-200",
      },
    },
  } as const,
  defaultVariants: {
    active: false,
  },
});

export const ResearchBreadcrumbs: React.FC<{
  list: ({ name: string; value: string } | undefined)[];
  active: string;
  onPress?: (value?: string) => void;
}> = ({ list, active, onPress }) => {
  return (
    <XStack
      justifyContent={"flex-start"}
      gap={"$1"}
      data-id="research-breadcrumbs"
    >
      {list.map((item, i) => (
        <React.Fragment key={item?.value}>
          <Button
            cursor="pointer"
            onPress={() => onPress?.(item?.value)}
            unstyled
          >
            <ResearchBreadcrumbsItem active={active === item?.value}>
              {item?.name}
            </ResearchBreadcrumbsItem>
          </Button>
          {i !== list.length - 1 && (
            <View paddingTop={"$1.3"}>
              <ChevronRight />
            </View>
          )}
        </React.Fragment>
      ))}
    </XStack>
  );
};
